import {
  CREATE_RESOURCE_INIT,
  CREATE_RESOURCE_SUCCESS,
  CREATE_RESOURCE_FAILED,
  GET_RESOURCE_ANALYTICS_INIT,
  GET_RESOURCE_ANALYTICS_SUCCESS,
  GET_RESOURCE_ANALYTICS_FAILED,
  GET_TOTAL_RESOURCES_INIT,
  GET_TOTAL_RESOURCES_SUCCESS,
  GET_TOTAL_RESOURCES_FAILED,
  GET_RESOURCES_BY_ROLES_INIT,
  GET_RESOURCES_BY_ROLES_SUCCESS,
  GET_RESOURCES_BY_ROLES_FAILED,
  GET_RESOURCE_DETAILS_BY_ID_INIT,
  GET_RESOURCE_DETAILS_BY_ID_SUCCESS,
  GET_RESOURCE_DETAILS_BY_ID_FAILED,
  UPDATE_RESOURCE_DETAILS_INIT,
  UPDATE_RESOURCE_DETAILS_SUCCESS,
  UPDATE_RESOURCE_DETAILS_FAILED,
  GET_RESOURCE_ALLOCATION_MATRIX_INIT,
  GET_RESOURCE_ALLOCATION_MATRIX_SUCCESS,
  GET_RESOURCE_ALLOCATION_MATRIX_FAILED,
  GET_UTILIZATION_LEVEL_INIT,
  GET_UTILIZATION_LEVEL_SUCCESS,
  GET_UTILIZATION_LEVEL_FAILED,
  CLEAR_RM_LANDING_DATA,
  GET_UTILIZATION_PERCENTAGE_INIT,
  GET_UTILIZATION_PERCENTAGE_SUCCESS,
  GET_UTILIZATION_PERCENTAGE_FAILED,
  GET_PROJECT_LIST_INIT,
  GET_PROJECT_LIST_SUCCESS,
  GET_PROJECT_LIST_FAILED,
  GET_RESOURCES_BY_LOCATION_INIT,
  GET_RESOURCES_BY_LOCATION_SUCCESS,
  GET_RESOURCES_BY_LOCATION_FAILED,
  GET_UTILIZATION_GRAPH_BY_ID_INIT,
  GET_UTILIZATION_GRAPH_BY_ID_SUCCESS,
  GET_UTILIZATION_GRAPH_BY_ID_FAILED,
  GET_INHOUSE_RESOURCE_DETAILS_INIT,
  GET_INHOUSE_RESOURCE_DETAILS_SUCCESS,
  GET_INHOUSE_RESOURCE_DETAILS_FAILED,
  GET_VENDOR_RESOURCE_DETAILS_INIT,
  GET_VENDOR_RESOURCE_DETAILS_SUCCESS,
  GET_VENDOR_RESOURCE_DETAILS_FAILED,
  GET_RESOURCE_ALLOCATION_MATRIX_DATA_LIMITS,
  GET_RESOURCE_ALLOCATION_MATRIX_DATA_LIMITS_FAILED,
  GET_RESOURCE_ALLOCATION_MATRIX_DATA_LIMITS_SUCCESS,
  UPDATE_RESOURCE_ALLOCATION_MATRIX_DATA_FTE,
  UPDATE_RESOURCE_ALLOCATION_MATRIX_DATA_FTE_SUCCESS,
  UPDATE_RESOURCE_ALLOCATION_MATRIX_DATA_FTE_FAILED,
  GET_DEPARTMENTS_RESOURCES_INIT,
  GET_DEPARTMENTS_RESOURCES_SUCCESS,
  GET_DEPARTMENTS_RESOURCES_FAILED,
  GET_RESOURCES_BY_DEPARTMENT_INIT,
  GET_RESOURCES_BY_DEPARTMENT_SUCCESS,
  GET_RESOURCES_BY_DEPARTMENT_FAILED,
  GET_RESOURCES_BY_PROJECT_INIT,
  GET_RESOURCES_BY_PROJECT_SUCCESS,
  GET_RESOURCES_BY_PROJECT_FAILED,
  GET_RESOURCES_BY_UTILIZATION_INIT,
  GET_RESOURCES_BY_UTILIZATION_SUCCESS,
  GET_RESOURCES_BY_UTILIZATION_FAILED,
  GET_AGGREGATE_RESOURCE_ALLOCATION_MATRIX_INIT,
  GET_AGGREGATE_RESOURCE_ALLOCATION_MATRIX_SUCCESS,
  GET_AGGREGATE_RESOURCE_ALLOCATION_MATRIX_FAILED,
  GET_ALLOCATION_BY_MAPID_INIT,
  GET_ALLOCATION_BY_MAPID_SUCCESS,
  GET_ALLOCATION_BY_MAPID_FAILED,
  GET_RESOURCES_BY_PROJECT_OWNER_INIT,
  GET_RESOURCES_BY_PROJECT_OWNER_SUCCESS,
  GET_RESOURCES_BY_PROJECT_OWNER_FAILED,
  GET_RESOURCE_ALL_ALLOCATIONS_CHART_INIT,
  GET_RESOURCE_ALL_ALLOCATIONS_CHART_SUCCESS,
  GET_RESOURCE_ALL_ALLOCATIONS_CHART_FAILED,
  UPDATE_RESOURCE_ALL_ALLOCATIONS_CHART_INIT,
  UPDATE_RESOURCE_ALL_ALLOCATIONS_CHART_SUCCESS,
  UPDATE_RESOURCE_ALL_ALLOCATIONS_CHART_FAILED,
  DOWNLOAD_CREATE_RESOURCE_EXCEL_INIT,
  DOWNLOAD_CREATE_RESOURCE_EXCEL_SUCCESS,
  DOWNLOAD_CREATE_RESOURCE_EXCEL_FAILED,
  UPLOAD_RESOURCE_INIT,
  UPLOAD_RESOURCE_SUCCESS,
  UPLOAD_RESOURCE_FAILED,
  ALL_RESOURCES_GANTT_CHART_INIT,
  ALL_RESOURCES_GANTT_CHART_SUCCESS,
  ALL_RESOURCES_GANTT_CHART_FAILED,
  GET_RESOURCE_HIERARCHY_INIT,
  GET_RESOURCE_HIERARCHY_SUCCESS,
  GET_RESOURCE_HIERARCHY_FAILED,
  GET_SPECIFIC_RESOURCE_HIERARCHY_INIT,
  GET_SPECIFIC_RESOURCE_HIERARCHY_SUCCESS,
  GET_SPECIFIC_RESOURCE_HIERARCHY_FAILED,
  GET_RESOURCE_REQUESTS_INIT,
  GET_RESOURCE_REQUESTS_SUCCESS,
  GET_RESOURCE_REQUESTS_FAILED,
  GET_PROJECT_REQUESTS_INIT,
  GET_PROJECT_REQUESTS_SUCCESS,
  GET_PROJECT_REQUESTS_FAILED,
  DOWNLOAD_RESOURCE_ANALYTICS_INIT,
  DOWNLOAD_RESOURCE_ANALYTICS_SUCCESS,
  DOWNLOAD_RESOURCE_ANALYTICS_FAILED,
  DOWNLOAD_FILTERED_RESOURCE_ANALYTICS_INIT,
  DOWNLOAD_FILTERED_RESOURCE_ANALYTICS_SUCCESS,
  DOWNLOAD_FILTERED_RESOURCE_ANALYTICS_FAILED,
  GET_DEPARTMENTS_INIT,
  GET_DEPARTMENTS_SUCCESS,
  GET_DEPARTMENTS_FAILED,
  GET_DEPARTMENT_ALL_RESOURCES_ALLOCATIONS_INIT,
  GET_DEPARTMENT_ALL_RESOURCES_ALLOCATIONS_SUCCESS,
  GET_DEPARTMENT_ALL_RESOURCES_ALLOCATIONS_FAILED,
  GET_SWAP_RESOURCES_ELIGIBLE_LIST_INIT,
  GET_SWAP_RESOURCES_ELIGIBLE_LIST_SUCCESS,
  GET_SWAP_RESOURCES_ELIGIBLE_LIST_FAILED,
  SWAP_RESOURCE_INIT,
  SWAP_RESOURCE_SUCCESS,
  SWAP_RESOURCE_FAILED,
  GET_SEARCH_FILTERS_FOR_UNNAMED_INIT,
  GET_SEARCH_FILTERS_FOR_UNNAMED_SUCCESS,
  GET_SEARCH_FILTERS_FOR_UNNAMED_FAILED,
  ASSIGN_RESOURCE_TO_UNNAMED_INIT,
  ASSIGN_RESOURCE_TO_UNNAMED_SUCCESS,
  ASSIGN_RESOURCE_TO_UNNAMED_FAILED,
  GET_ALLOCATION_MATRIX_ALL_RESOURCES_INIT,
  GET_ALLOCATION_MATRIX_ALL_RESOURCES_SUCCESS,
  GET_ALLOCATION_MATRIX_ALL_RESOURCES_FAILED,
  GET_PROFILE_INIT,
  GET_PROFILE_SUCCESS,
  GET_PROFILE_FAILED,
  GET_PROJECT_NOTIFICATION_COUNT_INIT,
  GET_PROJECT_NOTIFICATION_COUNT_SUCCESS,
  GET_PROJECT_NOTIFICATION_COUNT_FAILED,
  GET_NOTIFICATION_VIEWED_INIT,
  GET_NOTIFICATION_VIEWED_SUCCESS,
  GET_NOTIFICATION_VIEWED_FAILED,
  CLEAR_NOTIFICATIONS,
  CLEAR_GANTT_CHART_BY_DEPARTMENT,
  CLEAR_GANTT_CHART_BY_NAMED,
  COMPLIANCE_REPORT_RESOURCE_INIT,
  COMPLIANCE_REPORT_RESOURCE_SUCCESS,
  COMPLIANCE_REPORT_RESOURCE_FAILED,
  DOWNLOAD_COMPLIANCE_REPORT_RESOURCE_INIT,
  DOWNLOAD_COMPLIANCE_REPORT_RESOURCE_SUCCESS,
  DOWNLOAD_COMPLIANCE_REPORT_RESOURCE_FAILED,
  ACCEPT_COMPLETE_RESOURCE_INIT,
  ACCEPT_COMPLETE_RESOURCE_SUCCESS,
  ACCEPT_COMPLETE_RESOURCE_FAILED,
  DOWNLOAD_RESOURCE_INIT,
  DOWNLOAD_RESOURCE_SUCCESS,
  DOWNLOAD_RESOURCE_FAILED,
  UPDATE_RESOURCES_BY_PROJECT_INIT,
  UPDATE_RESOURCES_BY_PROJECT_SUCCESS,
  UPDATE_RESOURCES_BY_PROJECT_FAILED,
  GET_REQUEST_DETAILS_BY_MAPID_INIT,
  GET_REQUEST_DETAILS_BY_MAPID_SUCCESS,
  GET_REQUEST_DETAILS_BY_MAPID_FAILED,
  REJECT_RESOURCE_INIT,
  REJECT_RESOURCE_SUCCESS,
  REJECT_RESOURCE_FAILED,
  ACCEPT_ALL_RESOURCE_REQUESTS_INIT,
  ACCEPT_ALL_RESOURCE_REQUESTS_SUCCESS,
  ACCEPT_ALL_RESOURCE_REQUESTS_FAILED,
  ACCEPT_ALL_RESOURCE_REQUESTS_BY_PROJECT_INIT,
  ACCEPT_ALL_RESOURCE_REQUESTS_BY_PROJECT_SUCCESS,
  ACCEPT_ALL_RESOURCE_REQUESTS_BY_PROJECT_FAILED,
} from "./types/resource-management-types";
import {
  createResourceAPI,
  getResourceAnalyticsAPI,
  getResourcesByRolesAPI,
  getTotalResourcesAPI,
  getResourceDetailsByIdAPI,
  updateResourceDetailsByIdAPI,
  getResourceAllocationMatrixAPI,
  getResourceAllocationDataLimitsByMapIdAPI,
  createUpdateProjectResourceAllocationAPI,
  getUtilizationLevelAPI,
  getUtilizationPercentAPI,
  getProjectListAPI,
  getResourcesByLocationAPI,
  getUtilizationGraphAPI,
  getInHouseResourceDetailsAPI,
  getVendorResourceDetailsAPI,
  getResourcesByDepartmentAPI,
  getResourcesByProjectAPI,
  getResourcesByUtilizationAPI,
  getResourceAllocationMatrixNewAPI,
  getAllocationDataByMapIdAPI,
  getResourcesByProjectOwnerAPI,
  getResourceAllAllocationsChartAPI,
  updateResourceAllAllocationsChartAPI,
  downloadCreateResourceExcelFileAPI,
  createResourceFromExcelAPI,
  getResourceAllocationChartForAllResourcesAPI,
  getDepartmentResourcesAPI,
  getResourceHierarchysAPI,
  getProjectNotificationAPI,
  getResourceNotificationAPI,
  getSpecificResourceHierarchysAPI,
  downloadResourceAnalyticsAPI,
  getDepartmentsAPI,
  getDepartmentAllResourceAllocationsChartAPI,
  swapResourceforResourceRequestAPI,
  sendResourceListEligibleForSwappingAPI,
  getSearchFiltersForUnnamedRequestAPI,
  assignResourceToUnnamedRequestAPI,
  getResourceAllocationMatrixForAllResourcesAPI,
  getUserProfileDetailsAPI,
  getNotificationCountAPI,
  notificationViewedByUserAPI,
  downloadRequestResponseActionReportAPI,
  getRequestResponseActionReportAPI,
  acceptCompleteResourceRequestAPI,
  downloadResourceAllAllocationsChartAPI,
  updateAllResourceAllAllocationsChartByProjectAPI,
  getResourceRequestDetailsByMapIdAPI,
  rejectResourceRequestAPI,
  acceptAllCompleteResourceRequestsAPI,
  acceptAllCompleteResourceRequestsByProjectAPI,
  downloadFilteredResourceAnalyticsAPI,
} from "../api/resource-management-api";

export function createResource(body) {
  return (dispatch) => {
    dispatch({ type: CREATE_RESOURCE_INIT });
    createResourceAPI(body)
      .then((response) => dispatch({ type: CREATE_RESOURCE_SUCCESS, response }))
      .catch((error) => dispatch({ type: CREATE_RESOURCE_FAILED, error }));
  };
}

export function getResourceAnalytics(body, id, isShowInactive) {
  return (dispatch) => {
    dispatch({ type: GET_RESOURCE_ANALYTICS_INIT });
    getResourceAnalyticsAPI(body, id, isShowInactive)
      .then((response) =>
        dispatch({ type: GET_RESOURCE_ANALYTICS_SUCCESS, response })
      )
      .catch((error) =>
        dispatch({ type: GET_RESOURCE_ANALYTICS_FAILED, error })
      );
  };
}

export function getResourcesByRoles(body, id, isShowInactive) {
  return (dispatch) => {
    dispatch({ type: GET_RESOURCES_BY_ROLES_INIT });
    getResourcesByRolesAPI(body, id, isShowInactive)
      .then((response) =>
        dispatch({ type: GET_RESOURCES_BY_ROLES_SUCCESS, response })
      )
      .catch((error) =>
        dispatch({ type: GET_RESOURCES_BY_ROLES_FAILED, error })
      );
  };
}

export function getTotalResources(body, id, isShowInactive) {
  return (dispatch) => {
    dispatch({ type: GET_TOTAL_RESOURCES_INIT });
    getTotalResourcesAPI(body, id, isShowInactive)
      .then((response) =>
        dispatch({ type: GET_TOTAL_RESOURCES_SUCCESS, response })
      )
      .catch((error) => dispatch({ type: GET_TOTAL_RESOURCES_FAILED, error }));
  };
}

export function getResourceDetailsById(id, financialYear) {
  return (dispatch) => {
    dispatch({ type: GET_RESOURCE_DETAILS_BY_ID_INIT });
    getResourceDetailsByIdAPI(id, financialYear)
      .then((response) =>
        dispatch({ type: GET_RESOURCE_DETAILS_BY_ID_SUCCESS, response })
      )
      .catch((error) =>
        dispatch({ type: GET_RESOURCE_DETAILS_BY_ID_FAILED, error })
      );
  };
}

export function updateResourceDetailsById(id, body) {
  return (dispatch) => {
    dispatch({ type: UPDATE_RESOURCE_DETAILS_INIT });
    updateResourceDetailsByIdAPI(id, body)
      .then((response) =>
        dispatch({ type: UPDATE_RESOURCE_DETAILS_SUCCESS, response })
      )
      .catch((error) =>
        dispatch({ type: UPDATE_RESOURCE_DETAILS_FAILED, error })
      );
  };
}

export function getResourceAllocationMatrix(id, body) {
  return (dispatch) => {
    dispatch({ type: GET_RESOURCE_ALLOCATION_MATRIX_INIT });
    getResourceAllocationMatrixAPI(id, body)
      .then((response) =>
        dispatch({ type: GET_RESOURCE_ALLOCATION_MATRIX_SUCCESS, response })
      )
      .catch((error) =>
        dispatch({ type: GET_RESOURCE_ALLOCATION_MATRIX_FAILED, error })
      );
  };
}
export function getResourceAllocationDataLimits(id, mapId, body) {
  return (dispatch) => {
    dispatch({ type: GET_RESOURCE_ALLOCATION_MATRIX_DATA_LIMITS });
    getResourceAllocationDataLimitsByMapIdAPI(id, mapId, body)
      .then((response) =>
        dispatch({
          type: GET_RESOURCE_ALLOCATION_MATRIX_DATA_LIMITS_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({
          type: GET_RESOURCE_ALLOCATION_MATRIX_DATA_LIMITS_FAILED,
          error,
        })
      );
  };
}
export function createUpdateProjectResourceAllocation(
  body,
  mapId,
  allocationFrequency,
  modifiedBy
) {
  return (dispatch) => {
    dispatch({ type: UPDATE_RESOURCE_ALLOCATION_MATRIX_DATA_FTE });
    createUpdateProjectResourceAllocationAPI(
      body,
      mapId,
      allocationFrequency,
      modifiedBy
    )
      .then((response) =>
        dispatch({
          type: UPDATE_RESOURCE_ALLOCATION_MATRIX_DATA_FTE_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({
          type: UPDATE_RESOURCE_ALLOCATION_MATRIX_DATA_FTE_FAILED,
          error,
        })
      );
  };
}

export function getDepartments() {
  return (dispatch) => {
    dispatch({ type: GET_DEPARTMENTS_INIT });
    getDepartmentsAPI()
      .then((response) => dispatch({ type: GET_DEPARTMENTS_SUCCESS, response }))
      .catch((error) => dispatch({ type: GET_DEPARTMENTS_FAILED, error }));
  };
}

export function clearRMLandingData() {
  return (dispatch) => {
    dispatch({ type: CLEAR_RM_LANDING_DATA });
  };
}

export function clearNotifications() {
  return (dispatch) => {
    dispatch({ type: CLEAR_NOTIFICATIONS });
  };
}

export function clearGanttChartByDepartment() {
  return (dispatch) => {
    dispatch({ type: CLEAR_GANTT_CHART_BY_DEPARTMENT });
  };
}

export function clearGanttChartByNamed() {
  return (dispatch) => {
    dispatch({ type: CLEAR_GANTT_CHART_BY_NAMED });
  };
}

export function getUtilizationLevel(body, id, isShowInactive) {
  return (dispatch) => {
    dispatch({ type: GET_UTILIZATION_LEVEL_INIT });
    getUtilizationLevelAPI(body, id, isShowInactive)
      .then((response) =>
        dispatch({ type: GET_UTILIZATION_LEVEL_SUCCESS, response })
      )
      .catch((error) =>
        dispatch({ type: GET_UTILIZATION_LEVEL_FAILED, error })
      );
  };
}

export function getUtilizationPercent(body, id, isShowInactive) {
  return (dispatch) => {
    dispatch({ type: GET_UTILIZATION_PERCENTAGE_INIT });
    getUtilizationPercentAPI(body, id, isShowInactive)
      .then((response) =>
        dispatch({ type: GET_UTILIZATION_PERCENTAGE_SUCCESS, response })
      )
      .catch((error) =>
        dispatch({ type: GET_UTILIZATION_PERCENTAGE_FAILED, error })
      );
  };
}
export function getResourceNotification(notificationType, showFulfilled) {
  return (dispatch) => {
    dispatch({ type: GET_RESOURCE_REQUESTS_INIT });
    getResourceNotificationAPI(notificationType, showFulfilled)
      .then((response) =>
        dispatch({ type: GET_RESOURCE_REQUESTS_SUCCESS, response })
      )
      .catch((error) =>
        dispatch({ type: GET_RESOURCE_REQUESTS_FAILED, error })
      );
  };
}
export function getProjectNotification(notificationType, showFulfilled) {
  return (dispatch) => {
    dispatch({ type: GET_PROJECT_REQUESTS_INIT });
    getProjectNotificationAPI(notificationType, showFulfilled)
      .then((response) =>
        dispatch({ type: GET_PROJECT_REQUESTS_SUCCESS, response })
      )
      .catch((error) => dispatch({ type: GET_PROJECT_REQUESTS_FAILED, error }));
  };
}
export function getProjectList() {
  return (dispatch) => {
    dispatch({ type: GET_PROJECT_LIST_INIT });
    getProjectListAPI()
      .then((response) =>
        dispatch({ type: GET_PROJECT_LIST_SUCCESS, response })
      )
      .catch((error) => dispatch({ type: GET_PROJECT_LIST_FAILED, error }));
  };
}

export function getResourcesByLocation(body, id, isShowInactive) {
  return (dispatch) => {
    dispatch({ type: GET_RESOURCES_BY_LOCATION_INIT });
    getResourcesByLocationAPI(body, id, isShowInactive)
      .then((response) =>
        dispatch({ type: GET_RESOURCES_BY_LOCATION_SUCCESS, response })
      )
      .catch((error) =>
        dispatch({ type: GET_RESOURCES_BY_LOCATION_FAILED, error })
      );
  };
}
export function getUtilizationGraph(id, isShowInactive) {
  return (dispatch) => {
    dispatch({ type: GET_UTILIZATION_GRAPH_BY_ID_INIT });
    getUtilizationGraphAPI(id, isShowInactive)
      .then((response) =>
        dispatch({ type: GET_UTILIZATION_GRAPH_BY_ID_SUCCESS, response })
      )
      .catch((error) =>
        dispatch({ type: GET_UTILIZATION_GRAPH_BY_ID_FAILED, error })
      );
  };
}

export function getInHouseResourceDetails(year) {
  return (dispatch) => {
    dispatch({ type: GET_INHOUSE_RESOURCE_DETAILS_INIT });
    getInHouseResourceDetailsAPI(year)
      .then((response) =>
        dispatch({ type: GET_INHOUSE_RESOURCE_DETAILS_SUCCESS, response })
      )
      .catch((error) =>
        dispatch({ type: GET_INHOUSE_RESOURCE_DETAILS_FAILED, error })
      );
  };
}

export function getVendorResourceDetails(year) {
  return (dispatch) => {
    dispatch({ type: GET_VENDOR_RESOURCE_DETAILS_INIT });
    getVendorResourceDetailsAPI(year)
      .then((response) =>
        dispatch({ type: GET_VENDOR_RESOURCE_DETAILS_SUCCESS, response })
      )
      .catch((error) =>
        dispatch({ type: GET_VENDOR_RESOURCE_DETAILS_FAILED, error })
      );
  };
}

export function getResourcesByDepartment(body) {
  return (dispatch) => {
    dispatch({ type: GET_RESOURCES_BY_DEPARTMENT_INIT });
    getResourcesByDepartmentAPI(body)
      .then((response) =>
        dispatch({ type: GET_RESOURCES_BY_DEPARTMENT_SUCCESS, response })
      )
      .catch((error) =>
        dispatch({ type: GET_RESOURCES_BY_DEPARTMENT_FAILED, error })
      );
  };
}

export function getResourcesByProject(body) {
  return (dispatch) => {
    dispatch({ type: GET_RESOURCES_BY_PROJECT_INIT });
    getResourcesByProjectAPI(body)
      .then((response) =>
        dispatch({ type: GET_RESOURCES_BY_PROJECT_SUCCESS, response })
      )
      .catch((error) =>
        dispatch({ type: GET_RESOURCES_BY_PROJECT_FAILED, error })
      );
  };
}

export function getResourcesByUtilization(body) {
  return (dispatch) => {
    dispatch({ type: GET_RESOURCES_BY_UTILIZATION_INIT });
    getResourcesByUtilizationAPI(body)
      .then((response) =>
        dispatch({ type: GET_RESOURCES_BY_UTILIZATION_SUCCESS, response })
      )
      .catch((error) =>
        dispatch({ type: GET_RESOURCES_BY_UTILIZATION_FAILED, error })
      );
  };
}

export function getResourceAllocationMatrixNew(body, dropdown, id) {
  return (dispatch) => {
    dispatch({ type: GET_AGGREGATE_RESOURCE_ALLOCATION_MATRIX_INIT });
    getResourceAllocationMatrixNewAPI(body, dropdown, id)
      .then((response) =>
        dispatch({
          type: GET_AGGREGATE_RESOURCE_ALLOCATION_MATRIX_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({
          type: GET_AGGREGATE_RESOURCE_ALLOCATION_MATRIX_FAILED,
          error,
        })
      );
  };
}

export function getAllocationDataByMapId(mapId) {
  return (dispatch) => {
    dispatch({ type: GET_ALLOCATION_BY_MAPID_INIT });
    getAllocationDataByMapIdAPI(mapId)
      .then((response) =>
        dispatch({
          type: GET_ALLOCATION_BY_MAPID_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({
          type: GET_ALLOCATION_BY_MAPID_FAILED,
          error,
        })
      );
  };
}

export function getResourcesByProjectOwner(dates) {
  return (dispatch) => {
    dispatch({ type: GET_RESOURCES_BY_PROJECT_OWNER_INIT });
    getResourcesByProjectOwnerAPI(dates)
      .then((response) =>
        dispatch({ type: GET_RESOURCES_BY_PROJECT_OWNER_SUCCESS, response })
      )
      .catch((error) =>
        dispatch({ type: GET_RESOURCES_BY_PROJECT_OWNER_FAILED, error })
      );
  };
}

export function getResourceAllAllocationsChart(
  resourceId,
  year,
  frequency,
  type = "department",
  id = 0
) {
  return (dispatch) => {
    dispatch({ type: GET_RESOURCE_ALL_ALLOCATIONS_CHART_INIT });
    getResourceAllAllocationsChartAPI(resourceId, year, type, id, frequency)
      .then((response) =>
        dispatch({ type: GET_RESOURCE_ALL_ALLOCATIONS_CHART_SUCCESS, response })
      )
      .catch((error) =>
        dispatch({ type: GET_RESOURCE_ALL_ALLOCATIONS_CHART_FAILED, error })
      );
  };
}

export function updateResourceAllAllocationsChart(
  frequency,
  body,
  goBeyondAvailableFteLimit
) {
  return (dispatch) => {
    dispatch({ type: UPDATE_RESOURCE_ALL_ALLOCATIONS_CHART_INIT });
    updateResourceAllAllocationsChartAPI(
      frequency,
      body,
      goBeyondAvailableFteLimit
    )
      .then((response) =>
        dispatch({
          type: UPDATE_RESOURCE_ALL_ALLOCATIONS_CHART_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({ type: UPDATE_RESOURCE_ALL_ALLOCATIONS_CHART_FAILED, error })
      );
  };
}

export function downloadCreateResourceExcelFile() {
  return (dispatch) => {
    dispatch({ type: DOWNLOAD_CREATE_RESOURCE_EXCEL_INIT });
    downloadCreateResourceExcelFileAPI()
      .then((response) =>
        dispatch({
          type: DOWNLOAD_CREATE_RESOURCE_EXCEL_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({ type: DOWNLOAD_CREATE_RESOURCE_EXCEL_FAILED, error })
      );
  };
}

export function createResourceFromExcel(body) {
  return (dispatch) => {
    dispatch({ type: UPLOAD_RESOURCE_INIT });
    createResourceFromExcelAPI(body)
      .then((response) =>
        dispatch({
          type: UPLOAD_RESOURCE_SUCCESS,
          response,
        })
      )
      .catch((error) => dispatch({ type: UPLOAD_RESOURCE_FAILED, error }));
  };
}

export function getResourceAllocationChartForAllResources(body, year) {
  return (dispatch) => {
    dispatch({ type: ALL_RESOURCES_GANTT_CHART_INIT });
    getResourceAllocationChartForAllResourcesAPI(body, year)
      .then((response) =>
        dispatch({
          type: ALL_RESOURCES_GANTT_CHART_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({ type: ALL_RESOURCES_GANTT_CHART_FAILED, error })
      );
  };
}

export function getDepartmentsResources() {
  return (dispatch) => {
    dispatch({ type: GET_DEPARTMENTS_RESOURCES_INIT });
    getDepartmentResourcesAPI()
      .then((response) =>
        dispatch({ type: GET_DEPARTMENTS_RESOURCES_SUCCESS, response })
      )
      .catch((error) =>
        dispatch({ type: GET_DEPARTMENTS_RESOURCES_FAILED, error })
      );
  };
}
export function getResourceHierarchy() {
  return (dispatch) => {
    dispatch({ type: GET_RESOURCE_HIERARCHY_INIT });
    getResourceHierarchysAPI()
      .then((response) =>
        dispatch({ type: GET_RESOURCE_HIERARCHY_SUCCESS, response })
      )
      .catch((error) =>
        dispatch({ type: GET_RESOURCE_HIERARCHY_FAILED, error })
      );
  };
}
export function getSpecificResourceHierarchy() {
  return (dispatch) => {
    dispatch({ type: GET_SPECIFIC_RESOURCE_HIERARCHY_INIT });
    getSpecificResourceHierarchysAPI()
      .then((response) =>
        dispatch({ type: GET_SPECIFIC_RESOURCE_HIERARCHY_SUCCESS, response })
      )
      .catch((error) =>
        dispatch({ type: GET_SPECIFIC_RESOURCE_HIERARCHY_FAILED, error })
      );
  };
}

export function downloadResourceAnalytics(body, departmentId) {
  return (dispatch) => {
    dispatch({ type: DOWNLOAD_RESOURCE_ANALYTICS_INIT });
    downloadResourceAnalyticsAPI(body, departmentId)
      .then((response) =>
        dispatch({ type: DOWNLOAD_RESOURCE_ANALYTICS_SUCCESS, response })
      )
      .catch((error) =>
        dispatch({ type: DOWNLOAD_RESOURCE_ANALYTICS_FAILED, error })
      );
  };
}

export function downloadFilteredResourceAnalytics(body, departmentId) {
  return (dispatch) => {
    dispatch({ type: DOWNLOAD_FILTERED_RESOURCE_ANALYTICS_INIT });
    downloadFilteredResourceAnalyticsAPI(body, departmentId)
      .then((response) =>
        dispatch({
          type: DOWNLOAD_FILTERED_RESOURCE_ANALYTICS_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({ type: DOWNLOAD_FILTERED_RESOURCE_ANALYTICS_FAILED, error })
      );
  };
}

export function getDepartmentAllResourceAllocationsChart(
  year,
  resourceId,
  frequency
) {
  return (dispatch) => {
    dispatch({ type: GET_DEPARTMENT_ALL_RESOURCES_ALLOCATIONS_INIT });
    getDepartmentAllResourceAllocationsChartAPI(year, resourceId, frequency)
      .then((response) =>
        dispatch({
          type: GET_DEPARTMENT_ALL_RESOURCES_ALLOCATIONS_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({
          type: GET_DEPARTMENT_ALL_RESOURCES_ALLOCATIONS_FAILED,
          error,
        })
      );
  };
}

export function getSearchFiltersForUnnamedRequest(requestId) {
  return (dispatch) => {
    dispatch({ type: GET_SEARCH_FILTERS_FOR_UNNAMED_INIT });
    getSearchFiltersForUnnamedRequestAPI(requestId)
      .then((response) =>
        dispatch({ type: GET_SEARCH_FILTERS_FOR_UNNAMED_SUCCESS, response })
      )
      .catch((error) =>
        dispatch({ type: GET_SEARCH_FILTERS_FOR_UNNAMED_FAILED, error })
      );
  };
}

export function emptySearchFiltersForUnnamedRequest(response) {
  return (dispatch) => {
    dispatch({ type: GET_SEARCH_FILTERS_FOR_UNNAMED_SUCCESS, response });
  };
}

export function assignResourceToUnnamedRequest(requestId, resourceId) {
  return (dispatch) => {
    dispatch({ type: ASSIGN_RESOURCE_TO_UNNAMED_INIT });
    assignResourceToUnnamedRequestAPI(requestId, resourceId)
      .then((response) =>
        dispatch({ type: ASSIGN_RESOURCE_TO_UNNAMED_SUCCESS, response })
      )
      .catch((error) =>
        dispatch({ type: ASSIGN_RESOURCE_TO_UNNAMED_FAILED, error })
      );
  };
}

export function sendResourceListEligibleForSwapping(projectId, resourceId) {
  return (dispatch) => {
    dispatch({ type: GET_SWAP_RESOURCES_ELIGIBLE_LIST_INIT });
    sendResourceListEligibleForSwappingAPI(projectId, resourceId)
      .then((response) =>
        dispatch({
          type: GET_SWAP_RESOURCES_ELIGIBLE_LIST_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({
          type: GET_SWAP_RESOURCES_ELIGIBLE_LIST_FAILED,
          error,
        })
      );
  };
}

export function swapResourceforResourceRequest(
  mapId,
  resourceId,
  roleId,
  request
) {
  return (dispatch) => {
    dispatch({ type: SWAP_RESOURCE_INIT });
    swapResourceforResourceRequestAPI(mapId, resourceId, roleId, request)
      .then((response) =>
        dispatch({
          type: SWAP_RESOURCE_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({
          type: SWAP_RESOURCE_FAILED,
          error,
        })
      );
  };
}

export function getResourceAllocationMatrixForAllResources(
  option,
  year,
  id,
  frequency
) {
  return (dispatch) => {
    dispatch({ type: GET_ALLOCATION_MATRIX_ALL_RESOURCES_INIT });
    getResourceAllocationMatrixForAllResourcesAPI(option, year, id, frequency)
      .then((response) =>
        dispatch({
          type: GET_ALLOCATION_MATRIX_ALL_RESOURCES_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({
          type: GET_ALLOCATION_MATRIX_ALL_RESOURCES_FAILED,
          error,
        })
      );
  };
}
export function getUserProfileDetails(email) {
  return (dispatch) => {
    dispatch({ type: GET_PROFILE_INIT });
    getUserProfileDetailsAPI(email)
      .then((response) =>
        dispatch({
          type: GET_PROFILE_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({
          type: GET_PROFILE_FAILED,
          error,
        })
      );
  };
}
export function getNotificationCount(isRMNotification) {
  return (dispatch) => {
    dispatch({ type: GET_PROJECT_NOTIFICATION_COUNT_INIT });
    getNotificationCountAPI(isRMNotification)
      .then((response) =>
        dispatch({ type: GET_PROJECT_NOTIFICATION_COUNT_SUCCESS, response })
      )
      .catch((error) =>
        dispatch({ type: GET_PROJECT_NOTIFICATION_COUNT_FAILED, error })
      );
  };
}
export function notificationViewedByUser(isRmTrue, requestId) {
  return (dispatch) => {
    dispatch({ type: GET_NOTIFICATION_VIEWED_INIT });
    notificationViewedByUserAPI(isRmTrue, requestId)
      .then((response) =>
        dispatch({ type: GET_NOTIFICATION_VIEWED_SUCCESS, response })
      )
      .catch((error) =>
        dispatch({ type: GET_NOTIFICATION_VIEWED_FAILED, error })
      );
  };
}

export function downloadRequestResponseActionReport() {
  return (dispatch) => {
    dispatch({ type: DOWNLOAD_COMPLIANCE_REPORT_RESOURCE_INIT });
    downloadRequestResponseActionReportAPI()
      .then((response) =>
        dispatch({
          type: DOWNLOAD_COMPLIANCE_REPORT_RESOURCE_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({ type: DOWNLOAD_COMPLIANCE_REPORT_RESOURCE_FAILED, error })
      );
  };
}

export function getRequestResponseActionReport() {
  return (dispatch) => {
    dispatch({ type: COMPLIANCE_REPORT_RESOURCE_INIT });
    getRequestResponseActionReportAPI()
      .then((response) =>
        dispatch({
          type: COMPLIANCE_REPORT_RESOURCE_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({ type: COMPLIANCE_REPORT_RESOURCE_FAILED, error })
      );
  };
}

export function acceptCompleteResourceRequest(
  mapId,
  goBeyondAvailableFteLimit,
  body
) {
  return (dispatch) => {
    dispatch({ type: ACCEPT_COMPLETE_RESOURCE_INIT });
    acceptCompleteResourceRequestAPI(mapId, goBeyondAvailableFteLimit, body)
      .then((response) =>
        dispatch({
          type: ACCEPT_COMPLETE_RESOURCE_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({ type: ACCEPT_COMPLETE_RESOURCE_FAILED, error })
      );
  };
}

export function rejectResourceRequest(mapId, body) {
  return (dispatch) => {
    dispatch({ type: REJECT_RESOURCE_INIT });
    rejectResourceRequestAPI(mapId, body)
      .then((response) =>
        dispatch({
          type: REJECT_RESOURCE_SUCCESS,
          response,
        })
      )
      .catch((error) => dispatch({ type: REJECT_RESOURCE_FAILED, error }));
  };
}

export function downloadResourceAllAllocationsChart(
  resourceId,
  year,
  type,
  id,
  frequency
) {
  return (dispatch) => {
    dispatch({ type: DOWNLOAD_RESOURCE_INIT });
    downloadResourceAllAllocationsChartAPI(
      resourceId,
      year,
      type,
      id,
      frequency
    )
      .then((response) =>
        dispatch({
          type: DOWNLOAD_RESOURCE_SUCCESS,
          response,
        })
      )
      .catch((error) => dispatch({ type: DOWNLOAD_RESOURCE_FAILED, error }));
  };
}

export function updateAllResourceAllAllocationsChartByProject(
  frequeny,
  goBeyondAvailableFteLimit,
  body
) {
  return (dispatch) => {
    dispatch({ type: UPDATE_RESOURCES_BY_PROJECT_INIT });
    updateAllResourceAllAllocationsChartByProjectAPI(
      frequeny,
      goBeyondAvailableFteLimit,
      body
    )
      .then((response) =>
        dispatch({
          type: UPDATE_RESOURCES_BY_PROJECT_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({ type: UPDATE_RESOURCES_BY_PROJECT_FAILED, error })
      );
  };
}

export function acceptAllCompleteResourceRequests(
  allowPastDataUpdate,
  goBeyondAvailableFteLimit,
  body
) {
  return (dispatch) => {
    dispatch({ type: ACCEPT_ALL_RESOURCE_REQUESTS_INIT });
    acceptAllCompleteResourceRequestsAPI(
      allowPastDataUpdate,
      goBeyondAvailableFteLimit,
      body
    )
      .then((response) =>
        dispatch({
          type: ACCEPT_ALL_RESOURCE_REQUESTS_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({ type: ACCEPT_ALL_RESOURCE_REQUESTS_FAILED, error })
      );
  };
}

export function acceptAllCompleteResourceRequestsByProject(
  allowPastDataUpdate,
  goBeyondAvailableFteLimit,
  body
) {
  return (dispatch) => {
    dispatch({ type: ACCEPT_ALL_RESOURCE_REQUESTS_BY_PROJECT_INIT });
    acceptAllCompleteResourceRequestsByProjectAPI(
      allowPastDataUpdate,
      goBeyondAvailableFteLimit,
      body
    )
      .then((response) =>
        dispatch({
          type: ACCEPT_ALL_RESOURCE_REQUESTS_BY_PROJECT_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({
          type: ACCEPT_ALL_RESOURCE_REQUESTS_BY_PROJECT_FAILED,
          error,
        })
      );
  };
}

export function getResourceRequestDetailsByMapId(mapId) {
  return (dispatch) => {
    dispatch({ type: GET_REQUEST_DETAILS_BY_MAPID_INIT });
    getResourceRequestDetailsByMapIdAPI(mapId)
      .then((response) =>
        dispatch({
          type: GET_REQUEST_DETAILS_BY_MAPID_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({ type: GET_REQUEST_DETAILS_BY_MAPID_FAILED, error })
      );
  };
}
